import './datatable.scss'
import { useState } from 'react'
import { Box, Chip, Divider, Fab, Link, Modal, Paper, TableContainer, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import { useTranslation } from 'react-i18next'
import { PaymentDetailsMap } from '../../utilities/maps/paymentDetails'

const DatatablePaymentDetails = ({ rows }) => {
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState([])
  const { t } = useTranslation(['common'])

  const columns = [
    {
      field: 'id',
      headerName: t('common:method'),
      flex: 1,
      minWidth: 220,
      renderCell: (params) => {
        return (
          <Box className="table-body-cell">
            {params.row.method && PaymentDetailsMap[params.row.method]
              ? params.row.method + '-' + params.row[PaymentDetailsMap[params.row.method]]
              : params.row.method
              ? params.row.method
              : '---'}
          </Box>
        )
      },
    },

    {
      field: 'details',
      headerName: t('common:details'),
      flex: 1,
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Link
            onClick={() => {
              setSelected(params.row)
              return setOpen(true)
            }}
          >
            {t('common:viewDetails')}
          </Link>
        )
      },
    },
  ]

  const renderObject = (obj) => {
    if (obj) {
      return Object.entries(obj).map(([key, value]) => {
        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          return (
            <Box key={key}>
              {/* <Typography variant="subtitle4">{key}</Typography> */}
              {renderObject(value)}
              <Divider sx={{ marginTop: '1rem' }} />
            </Box>
          )
        } else if (String(value).includes('[object Object]')) {
          return (
            <Box key={key}>
              <h4>{key.charAt(0).toUpperCase() + key.slice(1)}</h4>
              {value.map((element, index) => {
                return <Box key={index}>{renderObject(element)}</Box>
              })}
            </Box>
          )
        } else {
          return (
            <Box
              key={key}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '1rem',
                margin: '5px',
              }}
            >
              <Typography variant="subtitle4">{key.charAt(0).toUpperCase() + key.slice(1)}</Typography>

              <Chip
                sx={{ width: 'fit-content!important' }}
                variant="transparent"
                key={key}
                label={value.toString() === 'true' || value.toString() === 'false' ? value.toString() : value}
              />
            </Box>
          )
        }
      })
    }
    return 'No report'
  }

  return (
    <Box>
      <TableContainer>
        <DataGrid
          getRowId={(row) => `${row.method}-${Math.random().toString(36)}`}
          className="grid-table"
          rows={Array.isArray(rows) && rows}
          columns={columns}
          hideFooter={true}
          autoHeight={true}
        />
      </TableContainer>
      <Modal
        open={open}
        onClose={() => {
          setSelected('')
          return setOpen(false)
        }}
      >
        <Box className="modal">
          <Box className="modal-top">
            <Box className="modal-titles">
              <Typography variant="title">{t('common:savedPaymentDetail')}</Typography>
            </Box>
            <Fab variant="close" onClick={() => setOpen(false)}>
              <CloseOutlinedIcon />
            </Fab>
          </Box>

          <Divider />
          {selected && typeof selected === 'object' ? (
            <Paper elevation={0} className="transaction-payment-details">
              {renderObject(selected)}
            </Paper>
          ) : (
            ''
          )}
        </Box>
      </Modal>
    </Box>
  )
}

export default DatatablePaymentDetails
